import { Component, OnInit } from '@angular/core';
import { Footer } from '../../interfaces/footer';
import { WordpressService } from '../../services/wordpress.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footer: Footer;

  constructor(
    private wp: WordpressService
  ) {
    this.wp.getFooter().subscribe(res => {
      this.footer = res ? res.acf : null;
    });
  }

  ngOnInit() {
  }

}
